<template>
    <div v-b-visible.once="embedVisible">
        <div v-if="visible && (data.imgSrc || loading)">
            <div v-if="loading" class="text-center">
                <i class="fas fa-spinner fa-spin"></i>
            </div>
            <template v-else>
                <b-embed v-if="data.imageType == 'application/pdf'"
                         :key="`pdf-${data.id}-${renderNonce}`"
                         :src="data.imgSrc"
                         type="embed"/>
                <b-img-lazy v-else :src="data.imgSrc" fluid/>
            </template>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue, Watch} from "vue-property-decorator";
    import Axios from "axios";

    @Component({
        name: "IngestionImage"
    })
    export default class IngestionImage extends Vue {
        @VModel() private data!: any;
        // Re-keys the PDF embed on change so Edge rebuilds its viewer and can't leak rotation between items.
        @Prop({ default: 0 }) private renderNonce!: number;
        private visible = false;
        private loading = false;

        async embedVisible(vis: boolean) {
            if (vis && !this.visible) {
                this.visible = vis;
                // If we have an imageUrl but no imgSrc, fetch the image
                if (this.data.imageUrl && !this.data.imgSrc) {
                    await this.loadImage();
                }
            }
        }

        @Watch('data')
        onDataChange() {
            // When data object reference changes (new item from API), reload if already visible
            // Only reload images that were already in viewport - preserve lazy loading for off-screen items
            if (this.visible && this.data.imageUrl && !this.data.imgSrc) {
                this.loadImage();
            }
        }

        async loadImage() {
            if (this.loading || this.data.imgSrc) return;

            this.loading = true;
            try {
                const response = await Axios.get(this.data.imageUrl, { responseType: "blob" });
                const objectUrl = URL.createObjectURL(response.data);
                this.data.imgSrc = objectUrl;
                this.data.imageType = response.headers['content-type'] ?? "";
            } catch (err) {
                console.warn(`Failed to load image for queue item ${this.data.id}:`, err);
            } finally {
                this.loading = false;
            }
        }

        beforeDestroy() {
            if (this.data.imgSrc && this.data.imgSrc.startsWith('blob:')) {
                URL.revokeObjectURL(this.data.imgSrc);
            }
        }

    }
</script>

<style scoped>

</style>
